import React from 'react';
import { Modal, Button, Descriptions } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../../variables/api/axiosInstance';
import { formatMontant, formatDate } from '../../../../variables/constants';

export default function ValiderPrefinancementModal({ prefinancement, onClose, onSuccess }) {
    const { t } = useTranslation('dossierFinance');
    const [submitting, setSubmitting] = React.useState(false);
    if (!prefinancement) return null;

    const valider = async () => {
        setSubmitting(true);
        try {
            await axiosInstance.post(`/v1/prefinancements/${prefinancement.prefinancementTrackingId}/valider`);
            toast.success(t('prefinancements.valider.succes'));
            onSuccess?.();
        } catch (e) {
            toast.error(e.response?.data?.message || t('prefinancements.valider.erreur'));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal title={t('prefinancements.valider.titre')}
            open={!!prefinancement} onCancel={onClose} footer={null} destroyOnClose>
            <Descriptions column={1} size="small" bordered style={{ marginBottom: 20 }}>
                <Descriptions.Item label={t('prefinancements.valider.montant')}>{formatMontant(prefinancement.montantPrefinance)}</Descriptions.Item>
                <Descriptions.Item label={t('prefinancements.valider.dateDemande')}>{formatDate(prefinancement.datePrefinancement)}</Descriptions.Item>
                <Descriptions.Item label={t('prefinancements.valider.demandeur')}>{prefinancement.createdBy}</Descriptions.Item>
                <Descriptions.Item label={t('prefinancements.valider.motif')}>{prefinancement.motifDemande || '-'}</Descriptions.Item>
            </Descriptions>
            <p style={{ color: '#7c2d12', fontSize: 13 }}>
                <WarningOutlined /> {t('prefinancements.valider.avertissement')}
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <Button onClick={onClose}>{t('prefinancements.valider.retour')}</Button>
                <Button type="primary" loading={submitting} onClick={valider}
                    style={{ background: '#059669', borderColor: '#059669' }}>
                    {t('prefinancements.valider.confirmer')}
                </Button>
            </div>
        </Modal>
    );
}
